const Tabs = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-tabs"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-tabs"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M11,22H5c-2.757,0-5-2.243-5-5V9H11v13ZM24,7c0-2.757-2.243-5-5-5H5C2.243,2,0,4.243,0,7H24Zm-11,2v13h6c2.757,0,5-2.243,5-5V9H13Z" />
    </svg>
  );
};

export default Tabs;
